"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseError = /** @class */ (function () {
    /**
     * Create an instance of a base Error
     * @param error
     */
    function BaseError(error) {
        this.error = error;
    }
    /**
     * If this error is regarded as a recoverable error
     * @returns {boolean}
     */
    BaseError.prototype.isRecoverable = function () {
        return false;
    };
    /**
     * Gets the message for this error if possible
     * @returns {string}
     */
    BaseError.prototype.getMessage = function () {
        if (this.error instanceof Error && this.error.hasOwnProperty("message")) {
            return this.error.message;
        }
        else if (typeof this.error === "string") {
            return this.error;
        }
        else {
            return "Unknown Error";
        }
    };
    /**
     * Gets the raw error object
     */
    BaseError.prototype.getError = function () {
        return this.error;
    };
    /**
     * Gets the status code attributed with this error
     */
    BaseError.prototype.getStatusCode = function () {
        return "000";
    };
    return BaseError;
}());
exports.BaseError = BaseError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZUVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL0FQSS9TaW1wbGVBUEkvRXJyb3JzL0Jhc2VFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBO0lBRUU7OztPQUdHO0lBQ0gsbUJBQVksS0FBVTtRQUNwQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNyQixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksaUNBQWEsR0FBcEI7UUFDRSxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRDs7O09BR0c7SUFDSSw4QkFBVSxHQUFqQjtRQUNFLElBQUksSUFBSSxDQUFDLEtBQUssWUFBWSxLQUFLLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxjQUFjLENBQUMsU0FBUyxDQUFDLEVBQUU7WUFDdkUsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztTQUMzQjthQUFNLElBQUksT0FBTyxJQUFJLENBQUMsS0FBSyxLQUFLLFFBQVEsRUFBRTtZQUN6QyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7U0FDbkI7YUFBTTtZQUNMLE9BQU8sZUFBZSxDQUFDO1NBQ3hCO0lBQ0gsQ0FBQztJQUVEOztPQUVHO0lBQ0ksNEJBQVEsR0FBZjtRQUNFLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUNwQixDQUFDO0lBRUQ7O09BRUc7SUFDSSxpQ0FBYSxHQUFwQjtRQUNFLE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQTdDRCxJQTZDQztBQTdDWSw4QkFBUyJ9